<template>
<v-container fluid>
    <p class="text-h4 text--primary">Works</p>
    <v-divider class="my-5"></v-divider>
    <Tips />
    <p>その他ECサイト作成、APIを用いた音楽、書籍アプリなど作成経験有
    </p>

  </v-container>

</template>

<script>
import Tips from "../components/Works/Tips.vue";

export default {
  components: {
    Tips,
  },
};
</script>
